import { PageQuery } from "../../core/page-query/models/pageQuery";
import { parsePageQueryToFormFilter } from "../../core/page-query/parsers/parsePageQueryToFormFilter";
import {
    filterCompoundSeparator,
    filterSeparator
} from "../../core/page-query/consts/queryValueSeparators";

export function toFormQueryParam(pageQuery: PageQuery): string {
    const filter = parsePageQueryToFormFilter(pageQuery);
    const querySegments = [];
    if (filter.ssn) querySegments.push(`ssn=${filter.ssn}`);
    if (filter.name) querySegments.push(`name=${filter.name}`);
    if (filter.documentId)
        querySegments.push(`documentId=${filter.documentId}`);
    if (filter.errorTypes) {
        const types = filter.errorTypes.map((x) =>
            x.replaceAll(filterCompoundSeparator, filterSeparator)
        );
        querySegments.push(`errorTypes=${types}`);
    }

    if (filter.statusTypes) {
        const types = filter.statusTypes.map((x) =>
            x.replaceAll(filterCompoundSeparator, filterSeparator)
        );
        querySegments.push(`statusTypes=${types}`);
    }

    if (filter.municipalities) {
        const types = filter.municipalities.map((x) =>
            x.replaceAll(filterCompoundSeparator, filterSeparator)
        );
        querySegments.push(`municipalities=${types}`);
    }

    if (filter.period) {
        querySegments.push(
            `period=${filter.period.start.toISOString().slice(0, 10)},${filter.period.end.toISOString().slice(0, 10)}`
        );
    }
    if (filter.onlyFormsWithError) {
        querySegments.push(`onlyFormsWithError=true`);
    }

    if (pageQuery.page) {
        querySegments.push(`pageSize=${pageQuery.page.size}`);
        querySegments.push(`pageIndex=${pageQuery.page.index}`);
    }

    querySegments.push(`sortByField=${pageQuery.sortBy.field}`);
    querySegments.push(`sortByDirection=${pageQuery.sortBy.direction}`);

    let queryString: string = "";
    for (let i = 0; i < querySegments.length; i++) {
        let symbol;
        if (i === 0) {
            symbol = "?";
        } else {
            symbol = "&";
        }

        queryString += symbol + querySegments[i];
    }

    return queryString;
}
